import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  type TooltipDialogStyleOverrides,
} from "@newsela/angelou";

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";

export const tooltipIconCss = {
  root: {
    width: "20px",
    height: "20px",
  },
};

export const tooltipDialogCss: TooltipDialogStyleOverrides<CSSObject> = {
  dialog: {
    root: {
      zIndex: 2,
    },
    arrow: {
      display: "none",
    },
    Button: {
      root: {
        width: "16px",
        height: "16px",
        maxHeight: "16px",
      },
    },
  },
  Button: {
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "16px",
      height: "16px",
      maxHeight: "16px",
      borderRadius: "6px",

      "circle, path": {
        stroke: constants.colors.ui.core[700],
        strokeWidth: "4px",
      },
    },
  },
};

export const filterAndTooltipContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "4px",
  // justifyContent: 'space-between',
  // maxWidth: '243px',

  [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.MD}px)`]: {
    maxWidth: "inherit",
  },
};

export const filterAndTooltipContainerGradelevelCss: CSSObject = {
  border: 0,
  padding: 0,
  margin: 0,

  [`@media (min-width: ${SEARCH_PAGE_BREAKPOINTS.MD}px)`]: {
    maxWidth: "inherit",
  },
};

export const subHeadingCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.heading6,
  color: constants.colors.ui.neutral[700],
  margin: 0,
};

export const legendContentCss: CSSObject = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
};
